 
import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

const EventBookingModal = ({ modalOpen, toggleModal, iframeUrl }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {

       if (!event.data) return;

      if (event.data === "PAYMENT_SUCCESS") {
        console.log("Payment successful, closing modal");

        setIframeLoaded(false);

         toggleModal(false);

         window.location.reload();
      }

      if (event.data === "closeTicketBookingModal") {
        console.log("Closing booking modal");
        toggleModal(false);
      }

    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [toggleModal]);

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      size="xl"
      style={{ maxWidth: "80vw", width: "65%" }}
      backdrop={false} // Disable default backdrop click
    >
      <ModalHeader toggle={toggleModal}>Ticket Booking</ModalHeader>

      <ModalBody style={{ padding: 0, overflow: "hidden" }}>
        {iframeUrl ? (
          <iframe
            src={iframeUrl}
            title="Ticket Booking"
            width="100%"
            style={{
              border: "none",
              display: "block",
              height: "80vh",
              minHeight: "650px"
            }}
            onLoad={() => setIframeLoaded(true)}
          />
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "600px" }}
          >
            <Spinner color="primary" />
          </div>
        )}
        {!iframeLoaded && iframeUrl && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "80vh",
              background: "rgba(255,255,255,0.7)",
            }}
          >
            <Spinner color="primary" />
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EventBookingModal;